export default __webpack_public_path__ + "static/media/3d.c7bb468b.svg";